module.exports = __webpack_public_path__ + "static/media/flat-tire-crop.85b2e1be.jpg";